import { FileStatusType } from "@fronterahealth/frontera-ui-components";

export const isFileBusy = (fileStatus: FileStatusType) => {
  // Include classifying-success as busy to account for time between classification and parsing starting
  return ["parsing", "uploading", "classifying", "classifying-success", "ai-generating"].includes(fileStatus);
};
